// ----------------------------------------------------------------------

export default function Table(theme) {
    return {
        MuiTable: {
            styleOverrides: {
                root: {
                    margin: theme.spacing(2),
                },
            },
        },
    };
}
